






















































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { IAutocreditAccount, IAutocreditAccountBody, IOrganizations, PayloadState } from '@/types/types';

@Component({
  name: 'AutocreditBankDetailsDialog',
})
export default class AutocreditBankDetailsDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => [] }) organizations!: IOrganizations[];
  @Prop({ default: null }) account!: IAutocreditAccount | null;

  valid: boolean = false;
  form: IAutocreditAccountBody = this.emptyForm();

  rules = {
    required: (value: string) => !!value || 'This field is required',
  };

  get isEditing(): boolean {
    return !!this.account;
  }

  emptyForm(): IAutocreditAccountBody {
    return {
      organizationId: '',
      accountId: '',
      sortCode: '',
      transferType: 'BANK_TRANSFER',
      msisdn: '',
      autocreditEnabled: true,
    };
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    this.form = this.account
      ? {
          organizationId: String(this.account.organizationId),
          accountId: this.account.accountId,
          sortCode: this.account.sortCode,
          transferType: this.account.transferType || 'BANK_TRANSFER',
          msisdn: this.account.msisdn || '',
          autocreditEnabled: this.account.autocreditEnabled,
        }
      : this.emptyForm();
    (this.$refs.form as Vue & { resetValidation: () => void })?.resetValidation();
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('save')
  save(): IAutocreditAccountBody {
    const organization = this.organizations.find(({ _id }) => _id === this.form.organizationId);
    return {
      ...this.form,
      msisdn: this.form.msisdn || undefined,
      organizationName: organization?.name,
    };
  }
}
